import { render } from "./Diabetology.vue?vue&type=template&id=3a9b050b&scoped=true"
import script from "./Diabetology.vue?vue&type=script&lang=ts"
export * from "./Diabetology.vue?vue&type=script&lang=ts"

import "./Diabetology.vue?vue&type=style&index=0&id=3a9b050b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3a9b050b"

export default script